import SiteLayout from "./SiteLayout";

function SimplePage({ title, lead, sections }) {
  return (
    <SiteLayout>
      <section className="page-hero">
        <div className="container">
          <h1>{title}</h1>
          <p>{lead}</p>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <div className="split-grid">
            {sections.map((section, index) => (
              <div className="card" key={section.title} style={{ "--i": index }}>
                <h3>{section.title}</h3>
                <p>{section.text}</p>
                {section.items && (
                  <ul>
                    {section.items.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}

export default SimplePage;
